import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const MyHistory = lazy(() => import("@mediaspace/features/my-history"));

export const render = getDsLayoutComponentRenderer(MyHistory);

export { Remove as RemoveEntryAction } from "@mediaspace/features/my-history";
